import urlQuery from 'shared/lib/modules/urlQuery.js';

let initialQueryParams = {};

export function getFilterValuesFromUrl() {
    const filterState = {};
    const queryParams = urlQuery(window.location.href).queryParameters();
    Object.keys(queryParams).forEach(key => {
        if (
            (typeof queryParams[key] === 'string' || typeof queryParams[key] === 'number') &&
            queryParams[key] !== '' &&
            key !== 'tripType' &&
            key !== 'requestedOrigin' &&
            key !== 'requestedOrigin2' &&
            key !== 'requestedDestination' &&
            key !== 'requestedDestination2' &&
            key !== 'requestedDepartureDate' &&
            key !== 'requestedReturnDate' &&
            key !== 'numberOfAdults' &&
            key !== 'numberOfChildren' &&
            key !== 'childAges' &&
            key !== 'cabinType'
        ) {
            filterState[key] = queryParams[key];
            delete queryParams[key];
        }
    });
    initialQueryParams = queryParams;
    return filterState;
}

function addValuesToUrlFromFilterState(url, filterState) {
    Object.keys(filterState).forEach(key => {
        if (key === 'cabinType') {
            const cabinTypes = filterState[key]
                ? initialQueryParams.cabinType
                      .split(',')
                      .filter(item => filterState[key].split(',').indexOf(item) === -1)
                      .join(',')
                : initialQueryParams.cabinType;
            url = url.setQueryParameter(key, cabinTypes);
        } else if (key !== 'progress' && key !== 'pollingTimeOut' && filterState[key] !== '') {
            url = url.setQueryParameter(key, filterState[key]);
        }
    });
    return url;
}

function removeValuesFromUrlIfNotInFilterState(url, filterState) {
    Object.keys(url.queryParameters()).forEach(key => {
        const emptyKey = typeof filterState[key] === 'undefined' || filterState[key] === '';
        if (emptyKey && !initialQueryParams[key]) {
            url = url.deleteQueryParameter(key);
        }
    });
    return url;
}

export function updateUrl(filterState) {
    let url = urlQuery(window.location.href);

    url = addValuesToUrlFromFilterState(url, filterState);
    url = removeValuesFromUrlIfNotInFilterState(url, filterState);

    window.history.replaceState(null, window.document.title, url.toString(), false);
}

export function updateUrlForRequest(request) {
    let url = urlQuery(window.location.href);

    Object.keys(request).forEach(key => {
        if (request[key] && request[key] !== '') {
            url = url.setQueryParameter(key, request[key]);
        } else {
            url = url.deleteQueryParameter(key);
        }
    });

    window.history.replaceState(null, window.document.title, url.toString(), false);
}
